import PerformancePanel from "../components/PerformancePanel";

export default function PerformancePage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <PerformancePanel />
    </div>
  );
}